import { SET_SWITCHER } from './actionTypes';
import store from "../store";

export function setProdSwitcher(toggle) {
  return {
    type: SET_SWITCHER,
    payload: { toggle },
  };
}

export function enableProdSwitcher() {
  store.dispatch(setProdSwitcher(true));
  const now = new Date();
  const time = now.getTime();
  const expireTime = time + (1000 * 300);
  now.setTime(expireTime);
  document.cookie = 'prodmode=true;expires='+now.toUTCString()+';path=/';
}

export function disableProdSwitcher() {
  store.dispatch(setProdSwitcher(false));
  document.cookie = 'prodmode=; Max-Age=-99999999;';
}
